export default{
    cervicalLengthMeasurement:'Cervical Length Measurement',
    indication:'Indication',
    medicalAbbreviationTest:'Medical Abbreviation Test',
    gestationalMedicalAbbreviationTest:'gestational Medical Abbreviation Test',
    weeks:'Weeks',
    day:'Day',
    date:'Date',
    examinationMethod:'Examination Method',
    examinationView:'Examination View',
    cardiacActivity:'Cardiac Activity',
    cervixDescription:'Cervix Description',
    cervicalLengthMeasured:'Cervical Length Measured',
    placentaLocation:'Placenta Location',
    impressionLocation:'Impression Location',
    finalDescription:'Final Description',
}